export async function getRegData(reg: string, session?: number) {
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'car';

    let data = new FormData();
    data.append('reg', reg);
    if (session) data.append('session', session.toString());
    return await fetch(reactAppData.api_url+endPoint, {body:data, method:'post'})
        .then(res => res.json())
        .then(
            (result) => { return result },
            (error) => { return {error:error} }
        );
}
